// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"37da6daa","239":"74bb54cd","732":"36f08714"}[chunkId] + ".chunk.js";
};